export default "__VITE_ASSET__CdFykoUm__"